import logo from "../assets/lego/LEGO_F1-Logo.png";
import appicon from "../assets/lego/lego_appicon.webp";
import challengesCover from "../assets/lego/lego_challenges_cover.webp";

export const LEGO_brandVariables = {
  siteTitle: "LEGO",
  siteIcon: appicon,
  name: "LEGO",
  name_small: "LEGO",
  logos: {
    large: null,
    white: null,
    small: null,
    medium: null,
    alt_text: "LEGO logo",
    profile: null,
  },
  cover: {
    challenges: challengesCover,
  },
  tenantId: "LEGO-gdjkr",
  brandTheme: "lego", // Theme of the brand
  site: "lego.iplay.dk", // Live url of site
  authMethod: "email", // Only needed for events, gives user set options to manualy sign up, options are:  email | phone
  defaultCountryCode: "DK", // Only needed for retail platforms | For initial phone number | Changes all auth methods`
  defaultLanguage: "en",
  brandStoreExtension: "", // Only needed for retail platforms | Extension used for email
  brandValue: "LEGO", // Only needed for retail platforms | Brand value needed for BE related functions
  brandIntials: "", // gets added after the username, to drasticaly descrease chance of duplicate usernames across different apps | Only needed for event platforms
  defaultNavigateUrl: "/",
  eventHasAutoQrSignup: false,
  hasSubClients: false,
  subClientsForOverviews: null, // string[] of clients used to fetch multiple types of clients for overview pages
  autoJoinChallenge: true,
  hasFeature: {
    notifications: false,
    themes: false,
    connections: false,
    achievements: false,
    messages: false,
    teams: false,
    news: false,
    challenges: true,
    singleChallenge: true,
    preferences: false,
    friends: false,
    zones: false,
    feed: true,
    posts: false,
    winners: false, // !! Also add the data variables for this feature in brandVariables.tsx !!
    schedule: false, // !! Also add the data variables for this feature in brandVariables.tsx !!
    qrSignUp: true,
    manualSubmissions: false,
    landing: true,
    login: true,
    haslanguagePicker: true,
    getstarted: false,
    hero: false,
    search: false,
    routes: false,
    dailytasks: false,
    games: false,
    treasure_hunt: false,
    activities: false,
    changePassword: true,
    feedback: false,
    events: false,
  },
  hasAuth: {
    steam: false,
    bnet: false,
    quickSignUp: true,
    google: false,
    discord: false,
    twitch: false,
  },
  layout: {
    challenge: "default",
  },
  event: {
    forcedCredentialPopup: "email",
    eventCode: "", // Only needed for event platforms
    collectionForSubmissions: "",
    documentForSubmissions: "",
    isEvent: true,
    spacecoins_redirect: true,
  },
  hasCreate: {
    studio: false,
    challenges: false,
    news: false,
  },
};
